import { ButtonComponent, DividerComponent } from "@/components";
import { CurrencyConverter, IMAGES, WEB_COLORS } from "@/lib/constants";
import { Grid, Stack, Typography } from "@mui/material";
import Image from "next/image";
import { useState } from "react";

const EmiInsuranceBreakup = ({ insuranceData }) => {
  const {
    baseEmi,
    emiProtectionPlan,
    familyLoanDebtProtection,
    healthSubscriptionPlan,
    tenure,
    totalEmi,
  } = insuranceData;
  const [isMonthly, setIsMonthly] = useState(true);
  const DetailsField = (header, value) => {
    return (
      <Stack
        flexDirection={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Typography
          color={"#72727299"}
          fontWeight={{ xs: 500 }}
          fontSize={{ xs: "12px", sm: "14px" }}
        >
          {header}
        </Typography>
        <Typography
          color={WEB_COLORS.darkTeal}
          fontWeight={{ xs: 500 }}
          fontSize={{ xs: "12px", sm: "14px" }}
        >
          {CurrencyConverter(value, 2)}
        </Typography>
      </Stack>
    );
  };
  return (
    <Stack mb={4} mt={4} ml={{ xs: -1, md: 0 }}>
      <Grid container alignItems={"center"} justifyContent={"space-between"}>
        <Stack flexDirection={"row"} alignItems={"center"} gap={0.5}>
          <Image src={IMAGES.leftWindow} alt="hero-logo" />
          <Typography
            fontWeight={{ xs: 500, md: 700 }}
            fontSize={{ xs: "12px", md: "24px" }}
          >
            EMI + Insurance breakup
          </Typography>
        </Stack>

        <Stack flexDirection={"row"} gap={{ xs: 0.5, md: 1 }}>
          <ButtonComponent
            buttonStyle={{
              backgroundColor: isMonthly ? "#4D6767" : "#fff",
              color: isMonthly ? "#fff" : "#004135",
              height: 12,
            }}
            onClick={() => setIsMonthly(true)}
          >
            Monthly
          </ButtonComponent>
          <ButtonComponent
            buttonStyle={{
              backgroundColor: !isMonthly ? "#4D6767" : "#fff",
              color: !isMonthly ? "#fff" : "#004135",
              height: 12,
            }}
            onClick={() => setIsMonthly(false)}
          >
            Total
          </ButtonComponent>
        </Stack>
      </Grid>
      <Stack gap={2} mt={1} mb={2}>
        {DetailsField(
          `Base EMI Amount ${
            !isMonthly
              ? `for (${CurrencyConverter(baseEmi)} x ${tenure} months)`
              : ""
          } `,
          isMonthly ? baseEmi : totalEmi,
        )}
        {!!emiProtectionPlan &&
          DetailsField(
            `EMI Protection Plan ${
              !isMonthly
                ? `for (${CurrencyConverter(
                    emiProtectionPlan / tenure,
                  )} x ${tenure} months)`
                : ""
            }`,
            isMonthly ? emiProtectionPlan / tenure : emiProtectionPlan,
          )}
        {!!healthSubscriptionPlan &&
          DetailsField(
            `Health Subscription Plan
                ${
                  !isMonthly
                    ? `for (${CurrencyConverter(
                        healthSubscriptionPlan / tenure,
                      )} x ${tenure} months)`
                    : ""
                }`,
            isMonthly
              ? healthSubscriptionPlan / tenure
              : healthSubscriptionPlan,
          )}
        {!!familyLoanDebtProtection &&
          DetailsField(
            `Protect your family from Loan Debt
                ${
                  !isMonthly
                    ? `for (${CurrencyConverter(
                        familyLoanDebtProtection / tenure,
                      )} x ${tenure} months)`
                    : ""
                }`,
            isMonthly
              ? familyLoanDebtProtection / tenure
              : familyLoanDebtProtection,
          )}
      </Stack>
      <DividerComponent />
      <Stack
        flexDirection={"row"}
        justifyContent={"space-between"}
        mt={2}
        // mt={4}
      >
        <Typography
          fontWeight={400}
          fontSize={{ xs: "12px", sm: "16px" }}
          color={WEB_COLORS.darkTeal}
        >
          Total EMI Amount with insurance
        </Typography>
        <Typography
          fontWeight={700}
          fontSize={{ xs: "12px", sm: "16px" }}
          color={WEB_COLORS.darkTeal}
        >
          {isMonthly
            ? CurrencyConverter(
                Math.ceil(
                  baseEmi +
                    (emiProtectionPlan !== 0.0
                      ? emiProtectionPlan / tenure
                      : 0) +
                    (familyLoanDebtProtection !== 0.0
                      ? familyLoanDebtProtection / tenure
                      : 0) +
                    (healthSubscriptionPlan !== 0.0
                      ? healthSubscriptionPlan / tenure
                      : 0),
                ),
              )
            : CurrencyConverter(
                Math.ceil(
                  totalEmi +
                    emiProtectionPlan +
                    familyLoanDebtProtection +
                    healthSubscriptionPlan,
                ),
              )}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default EmiInsuranceBreakup;
